import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@components/Box/Box';
import MessageParts from '@components/Chat/MessageParts';
import { Message } from '@graphql/generated';
import { triggersConfig } from '@utils/mentions';

interface ActivityItemMessagePartProps {
  message: Message;
  authorName: string;
  messageContent: JSX.Element;
  filterVal?: string;
}

export const ActivityItemMessagePart: React.FC<
  ActivityItemMessagePartProps
> = ({ message, messageContent, filterVal }) => {
  const { t } = useTranslation('models');
  const { body, attachments, checkin } = message;

  if (
    (attachments ?? []).filter(
      (a) =>
        a.__typename !== 'Document' &&
        a.__typename !== 'MessageProject' &&
        a.__typename !== 'MessageTask'
    ).length === 0 ||
    checkin
  )
    return (
      <>
        <Box borderWidth={0} borderRadius='xs'>
          {!!body ? (
            <Box>
              <MessageParts
                value={body}
                configs={[triggersConfig.mention]}
                styleLinks
                filterVal={filterVal}
                textColor='textSecondary'
                textVariant='webBodySecondary'
                disableLongPress
              />
            </Box>
          ) : (
            checkin && (
              <Box>
                <MessageParts
                  value={t('chat.checkin.readyToWork')}
                  configs={[triggersConfig.mention]}
                  styleLinks
                  filterVal={filterVal}
                  textColor='textSecondary'
                  textVariant='webBodySecondary'
                  disableLongPress
                />
              </Box>
            )
          )}

          {messageContent}
        </Box>
      </>
    );
  else {
    return messageContent;
  }
};
